import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import { ThemeProvider } from './context/ThemeContext';
import BottomNavigation from './components/BottomNavigation';
import Login from './screens/Login';
import SignUp from './screens/SignUp';
import ForgotPassword from './screens/ForgotPassword';
import VerifyOtp from './screens/VerifyOtp';
import ResetPassword from './screens/ResetPassword';
import ApprovalPending from './screens/ApprovalPending';
import AccessDenied from './screens/AccessDenied';
import Dashboard from './screens/Dashboard';
import History from './screens/History';
import Alerts from './screens/Alerts';
import PickupDetails from './screens/PickupDetails';
import PickupProcess from './screens/PickupProcess';
import LogItem from './screens/LogItem';
import PickupSummary from './screens/PickupSummary';
import Account from './screens/Account';
import ChangePassword from './screens/ChangePassword';
import EditProfile from './screens/EditProfile';
import HelpSupport from './screens/HelpSupport';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <AppProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/verify-otp" element={<VerifyOtp />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/approval-pending" element={<ApprovalPending />} />
              <Route path="/access-denied" element={<AccessDenied />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/history" element={<History />} />
              <Route path="/alerts" element={<Alerts />} />
              <Route path="/pickup/:orderId" element={<PickupDetails />} />
              <Route path="/pickup/:orderId/process" element={<PickupProcess />} />
              <Route path="/pickup/:orderId/log-item/:itemId" element={<LogItem />} />
              <Route path="/pickup/:orderId/summary" element={<PickupSummary />} />
              <Route path="/account" element={<Account />} />
              <Route path="/account/change-password" element={<ChangePassword />} />
              <Route path="/account/edit-profile" element={<EditProfile />} />
              <Route path="/account/help-support" element={<HelpSupport />} />
              <Route path="/" element={<Navigate to="/login" replace />} />
            </Routes>
            <BottomNavigation />
          </div>
        </Router>
      </AppProvider>
    </ThemeProvider>
  );
}

export default App;

